import React, { useState, useEffect, useMemo, useRef } from "react";
import { Clock, ArrowRight, CheckCircle, X, CircleX, ChevronDown } from "lucide-react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-hot-toast';
import {
  fetchBookingDetails, sendconfirmation, selectBookingDetails, selectBookingDetailsStatus, DoUpdatediscountMarkup, DoSendticket,
  DoTicketUnhold, doBookingProcess
} from "./flightSlice";
import { selectCurrentUser } from "../auth/authSlice";
import ItineraryLoader from "../../components/ItineraryLoader";
import FareSummary from "./FareSummary";
import Moment from 'moment';
import { Dialog } from "@headlessui/react";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { getbaseURL, getcrmbaseURL } from "../../api/axios";
import WalletUtils from "../../utils/walletUtils";
import { usePaymentProcessRecharge } from "../../services/usePaymentProcessRecharge";
import { getapiKey } from "../../api/axios";
import { encryptAES } from "../../utils/crypto";
import CurFt from "../../components/CurFt";

export default function BookingConfirmation() {
  useDocumentTitle('Booking Confirmation');
  const { BookingID } = useParams()
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const BookingDetails = useSelector(selectBookingDetails);
  const BookingDetailsStatus = useSelector(selectBookingDetailsStatus);
  const user = useSelector(selectCurrentUser)

  const [TotalBagPrice, setTotalBagPrice] = useState(0)
  const [TotalMealPrice, setTotalMealPrice] = useState(0)
  const [BookingData, setBookingData] = useState([]);
  const [Sectors, setSectors] = useState([]);
  const [fare, setfare] = useState([]);
  const [TotalSSR, setTotalSSR] = useState(0)
  const [SeatPrice, setSeatPrice] = useState(0);
  const [params, setparams] = useState([]);
  const [customer, setMemberDetails] = useState([])
  const [PNRNumber, setPNRNumber] = useState('')
  const [GDSPNRNumber, setGDSPNRNumber] = useState('')
  const [isBookingStatus, setisBookingStatus] = useState(0)
  const [supplierType, setSupplierType] = useState(0);
  const [remarks, setremarks] = useState('')
  const [HoldPaymentStatus, setHoldPaymentStatus] = useState(0)
  const [PayType, SetPayType] = useState(1);
  const [timeLimit, settimeLimit] = useState(new Date())
  const [usewallet, setUsewallet] = useState(false)
  const [bookable_balance, setbookable_balance] = useState(0)

  const [errorMessageRecharge, SetErrorMessageRecharge] = useState('loading');
  const [paymentHookStatusRecharge, setpaymentHookStatusRecharge] = useState(null);
  const [ResponseData, SetResponseData] = useState(null);
  const { handleProceedRecharge } = usePaymentProcessRecharge({
    SetErrorMessageRecharge: SetErrorMessageRecharge,
    setpaymentHookStatusRecharge: setpaymentHookStatusRecharge,
    SetResponseData: SetResponseData,
  });

  const [currency, setCurrency] = useState({
    CurrencyRate: "1",
    CurrencyTitle: "INR",
    CurrencyId: 1,
  }); // 15 min session

  const initialFormData = {
    displayServiceFee: 1,
    showPrice: 1,
    action: 0,
    agentDetails: true,
    tax: true,
    passportInfo: true,
    emailid: '',
    mobile: '',
    amount: 0,
    Discount: 0,
    countrycode: '',
    Name: '',
    BookingID: BookingID,
  };
  const [formData, setFormData] = useState(initialFormData);
  const [formDataHold, setFormDataHold] = useState({
    BookingID: BookingID,
    isHoldconfirm: true,
    isapibooking: true,
    usewallet: false,
    pnrs: [],
    action: 0,
    amount: 0,
    paymentMode: '1',
  });

  const [Processing, setProcessing] = useState(false);

  useEffect(() => {
    if (BookingID && currency) {
      dispatch(fetchBookingDetails({ BookingID, currency }));
    }
  }, [BookingID, dispatch]);

  const getBookingStatus = (list) => {
    const uniqueValues = [...new Set(list.map(i => i.is_amendments))];

    // If both 0 and 1 मौजूद हैं
    if (uniqueValues.includes(1) && uniqueValues.includes(0)) {
      return 7;
    }

    // Otherwise return BookingStatus
    return list[0]?.BookingStatus || 0;
  };
  const validationData = BookingDetails || {};
  const validationStatus = BookingDetailsStatus || "idle";

  const isLoading = validationStatus === "loading";
  useEffect(() => {
    if (validationStatus === "succeeded" && validationData) {
      const data = validationData?.data || []
      if (data?.BookingDetails[0]?.BookingStatus === 0 || HoldPaymentStatus === 1) {
        setTimeout(() => {
          dispatch(fetchBookingDetails({ BookingID, currency }));
        }, 3000);
      }

      if (validationData.status.success) {

        if (data.BookingDetails[0]?.BookingStatus > 0) {
          let confirmed = {
            "BookingID": BookingID,
            "PlanType": 1,
          }
          if (data.BookingDetails[0]?.mailsent === 0) {
            dispatch(sendconfirmation({ confirmed }));
          }
          setHoldPaymentStatus(0)
        }

        setbookable_balance(validationData.WalletBalance.balances.bookable_balance)
        settimeLimit(data.BookingDetails[0]?.timeLimit);
        (getBookingStatus(data.BookingDetails));

        setisBookingStatus(getBookingStatus(data.BookingDetails));

        setSupplierType(data.BookingDetails[0]?.supplierType);
        setremarks(data.remarks);
        setBookingData(data.BookingDetails)
        setNotes(data.notes);
        setSectors(data.Sectors)
        setfare(data.fare)
        SetBOOKINGSTATUS(validationData?.BOOKINGSTATUS || {});
        setMemberDetails(data.customer)
        setPNRNumber(data.PNRNumber)
        setGDSPNRNumber(data.GDSPNRNumber)

        setFormData(prev => ({
          ...prev,
          ['displayServiceFee']: data.fare.displayServiceFee,
          ['amount']: data.fare.ExtraServiceFee,
          ['Discount']: data.fare.OtherDiscount,
        }));
      } else {
        toast.error(data.message, { autoClose: 2000 });
      }
    } else if (validationStatus === "failed") {
      toast.error('Request longer available.Please try again', { autoClose: 2000 });
    }
  }, [validationStatus, validationData]);


  const TryAgain = (event) => {
    window.location.reload()
  }
  const ViewTicketDetails = () => {
    window.location.reload()
    // navigate(`/flight/booking-confirmation/${BookingData[0].BookingID}`)
  }

  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [bookingStatus, setbookingStatus] = useState('loading');
  const [ErrorMessage, SetErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isDialogOpenHold, setDialogOpenHold] = useState(false);
  const [baseURL, setbaseURL] = useState(getbaseURL());
  const [crmbaseURL, setcrmbaseURL] = useState(getcrmbaseURL());
  const [Titles, setTitles] = useState('');
  const [TitlesHold, setTitlesHold] = useState('');
  const [notes, setNotes] = useState(null);
  const [BOOKINGSTATUSS, SetBOOKINGSTATUS] = useState({});


  const handleClose = () => {
    setDialogOpen(false);
    setProcessing(false)
    setDialogOpenHold(false);
  };
  const handleHold = (Title, action) => {

    setTitlesHold(Title);
    setDialogOpenHold(true);
    setFormDataHold(prev => ({
      ...prev,
      ['action']: action
    }));
    setOpen(false)
  };
  const handleOpen = (Title, action) => {
    setTitles(Title);
    setDialogOpen(true);
    setFormData(prev => ({
      ...prev,
      ['action']: action
    }));
    setOpen(false)
  };
  const paymentModeHandle = (event) => {
    const { value } = event.target;
    let amount = 0;
    // fare.TotalGrand + fare.Totalagentmarkup
    if (value === '1' || value === '2') {
      amount = fare.TotalGrand
    } else {
      amount = fare.TotalGrand + fare.Totalagentmarkup
    }
    setFormDataHold(prev => ({
      ...prev,
      ['paymentMode']: value,
      ['amount']: amount,
    }));
  }
  const handleChangePNR = (e) => {
    const { value, checked } = e.target;
    setFormDataHold((prev) => {
      let updatedPNRs = [];
      if (checked) {
        // Add new PNR
        updatedPNRs = [...prev.pnrs, value];
      } else {
        // Remove unchecked PNR
        updatedPNRs = prev.pnrs.filter((pnr) => pnr !== value);
      }
      return {
        ...prev,
        pnrs: updatedPNRs,
      };
    });
  };
  const handleConfirmHold = async (e) => {
    e.preventDefault();
    setProcessing(true)
    if (formDataHold.action === 2) {
      if (formDataHold.pnrs.length === 0) {
        toast.error('Select atleast one PNR number!', { autoClose: 2000 });
        setProcessing(false)
        return false;
      }
      const response = await dispatch(
        DoTicketUnhold({ formDataHold })
      ).unwrap();
      const { data } = response;
      if (data.status.success) {
        toast.success(data.message, { autoClose: 2000 });
        setProcessing(false)
        setDialogOpenHold(false);
        navigate('/booking-calendar')
      } else {
        setDialogOpenHold(false);
        setProcessing(false)
        toast.error(data.message, { autoClose: 2000 });
      }
      // // SendEditTicket()
    } else {
      let bookingProcess = {
        "isHoldconfirm": true,
        "usewallet": false,
        "paymentMode": 1,
        "IsFlexiPayment": (PayType === '2') ? true : false,
        "usereward": false
      }
      if (formDataHold.paymentMode === '2' || formDataHold.paymentMode === '3') {
        setProcessing(true)
        let encrypt = encryptAES(JSON.stringify(bookingProcess), getapiKey(), getapiKey())
        let txnid = "TXN" + Date.now()
        // const decrypt = decryptAES('a3a83c379525b1251c7a2660c6ac120a', getapiKey(), getapiKey());

        let TotalGrand = 0;
        if (PayType === '2') {
          TotalGrand = (fare.BookAmt + fare.ProAmt + fare.GSTOnPro);
        } else if (formDataHold.paymentMode === '3') {
          TotalGrand = (fare.TotalGrand + fare.Totalagentmarkup);
        } else {
          TotalGrand = (fare.TotalGrand);
        }
        if (usewallet && formDataHold.paymentMode === '2') {
          TotalGrand = (TotalGrand - bookable_balance)
        }

        const hash = WalletUtils.walletCode(txnid, txnid, parseFloat(TotalGrand).toFixed(2), user?.UserData?.name, user?.UserData?.mobile, user?.UserData?.email, "Wallet Recharge");

        const customerInfo = {
          txnid: txnid,
          amount: parseFloat(TotalGrand).toFixed(2),
          name: user?.UserData?.name,
          email: user?.UserData?.email,
          phone: user?.UserData?.mobile,
          productinfo: "Wallet Recharge",
          surl: "http://localhost:3001/payment/payment-success",
          furl: "http://localhost:3001/payment/payment-success",
          udf1: BookingID,
          udf2: "1",
          udf3: "Web-B2B",
          udf4: user?.UserData?.user?.id, // customer id
          udf5: user?.UserData?.user?.AgencyID,
          udf6: "26",
          udf7: encrypt,
          udf8: "",
          udf9: "",
          udf10: "",
          securecode: hash,
        };

        handleProceedRecharge(customerInfo);
      } else {
        setIsModalSector(true)
        bookingProcess['isapibooking'] = true
        bookingProcess['BookingID'] = BookingID
        bookingProcess['currency'] = currency
        // console.log(bookingProcess); return false;

        try {
          const response = await dispatch(
            doBookingProcess({ bookingProcess, currency })
          ).unwrap();
          if (response.data.status.success) {
            setbookingStatus('success')
            setTimeout(function () {
              ViewTicketDetails()
            }, 1000);
          } else {
            SetErrorMessage(response.data.message)
            setbookingStatus('failed')
            toast.error(response.data.message, { autoClose: 2000 });
            setTimeout(() => {
              window.location.reload()
            }, 4000);
          }
        } catch (error) {
          toast.error('We regret to inform you that your booking could not be completed due to an internal issue.', { autoClose: 2000 });
          console.error("Error:", error);
        }
      }

    }

  };
  const [platform, Setplatform] = useState('');
  // useEffect(() => {
  //   if (navigator.userAgentData) {
  //     navigator.userAgentData.getHighEntropyValues([
  //       "platform",
  //       "platformVersion",
  //       "model",
  //       "uaFullVersion"
  //     ]).then(ua => {
  //       Setplatform(ua.platform)
  //       console.log(`${ua.platform} - ${ua.model || "Unknown Device"}`);
  //     });
  //   } else {
  //     console.log(navigator.userAgent);
  //   }
  // }, []);

  useEffect(() => {
    const detectPlatform = async () => {
      if (navigator.userAgentData?.getHighEntropyValues) {
        try {
          const ua = await navigator.userAgentData.getHighEntropyValues([
            "platform",
            "platformVersion",
            "model",
            "uaFullVersion"
          ]);
          Setplatform(ua.platform)
          // console.log(
          //   `UA-CH → Platform: ${ua.platform} (${ua.platformVersion || "Unknown"}) - ${ua.model || "Unknown Device"}`
          // );

          // If you need more detailed info, fallback to UA parsing
          if (ua.platform === "Windows") {
            const fullUA = navigator.userAgent;
            if (fullUA.includes("Windows NT 10.0")) {
              //console.log("Detailed OS: Windows 10 or 11");
            }
          }
        } catch (err) {
          console.error("UA-CH error:", err);
        }
      } else {
        // Fallback: parse userAgent
        const fullUA = navigator.userAgent;
        //console.log("UA String:", fullUA);

        if (/windows nt 10/i.test(fullUA)) Setplatform('Windows 10/11');
        else if (/android/i.test(fullUA)) Setplatform("Android");
        else if (/iphone|ipad|ipod/i.test(fullUA)) Setplatform("iOS");
        else if (/mac os/i.test(fullUA)) Setplatform("macOS");
        else if (/linux/i.test(fullUA)) Setplatform("Linux");
        else Setplatform("Unknown platform");
      }
    };

    detectPlatform();
  }, []);
  useEffect(() => {

    // console.log(platform);

  }, [platform]);




  useEffect(() => {
    if (paymentHookStatusRecharge === 'success' && ResponseData.udf6 === '26') {
      setHoldPaymentStatus(1)
      toast.success('Payment has been successfully done. Please wait...', { autoClose: 8000 });
      if (isBookingStatus === 26) {
        setTimeout(() => {
          dispatch(fetchBookingDetails({ BookingID, currency }));
        }, 4000);
      } else if (isBookingStatus === 1) {
        toast.success('Your hold ticket confirmed successfully. Please wait...', { autoClose: 8000 });
        setTimeout(() => {
          ViewTicketDetails()
        }, 4000);
      }

    } else if (paymentHookStatusRecharge === 'paymentfailed' && ResponseData.udf6 === '26') {
      toast.error(errorMessageRecharge, { autoClose: 4000 });
      setProcessing(false)
      window.location.reload()
    }

  }, [paymentHookStatusRecharge, errorMessageRecharge]);


  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
  }
  const UpdateEditDiscount = async () => {
    const response = await dispatch(
      DoUpdatediscountMarkup({ formData })
    ).unwrap();
    const { data } = response;

    if (data.status.success) {
      toast.success('Update Successfully', { autoClose: 2000 });
      let BookingDetails = data.BookingDetails
      setBookingData(BookingDetails.BookingDetails);
      setfare(BookingDetails.fare)
      setProcessing(false)
      setDialogOpen(false);
    } else {
      setProcessing(false)
      toast.error(data.message, { autoClose: 2000 });
    }

  }

  const SendEditTicket = async () => {
    const response = await dispatch(
      DoSendticket({ formData })
    ).unwrap();
    const { data } = response;
    if (data.status.success) {
      toast.success('Sent Mail Successfully', { autoClose: 2000 });
      setProcessing(false)
      setDialogOpen(false);
    } else {
      setProcessing(false)
      toast.error(data.message, { autoClose: 2000 });
    }
  }
  const handleConfirm = () => {
    setProcessing(true)
    if (formData.action == 6 || formData.action == 7) {
      UpdateEditDiscount()
    }
    if (formData.action == 2) {
      if (formData.Name === '') {
        toast.error('Enter Name', { autoClose: 2000 });
        setProcessing(false)
        return false;
      }
      if (formData.emailid === '') {
        toast.error('Enter email id', { autoClose: 2000 });
        setProcessing(false)
        return false;
      }
      SendEditTicket()
    }

    if (formData.action == 1 || formData.action == 3) {
      setProcessing(false)
      const queryString = objectToQueryString(formData);
      const url = crmbaseURL + '/api/flight/e-ticket/' + BookingID + '?' + queryString + '&token=' + user?.token;
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    if (formData.action == 8) {
      setProcessing(false)
      const queryString = objectToQueryString(formData);
      const url = crmbaseURL + '/api/flight/print-invoice/' + BookingID + '?' + queryString + '&token=' + user?.token + '&type=' + 'AGENCY';;
      window.open(url, '_blank', 'noopener,noreferrer');
    } else if (formData.action == 9) {
      setProcessing(false)
      const queryString = objectToQueryString(formData);
      const url = crmbaseURL + '/api/flight/print-invoice/' + BookingID + '?' + queryString + '&token=' + user?.token;
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    return false

    //let pdfUrl = 'https://www.ozilcrm.com/public/voucher.pdf';
    // const message = "Here's my flight e-ticket:";
    // const encodedMessage = encodeURIComponent(message);
    // window.open(`https://wa.me/?text=${encodedMessage}%20${encodeURIComponent(pdfUrl)}`, '_blank');


    // const previewImage =  pdfUrl;

    // const message = encodeURIComponent("Here's my flight e-ticket:");
    // const shareUrl = `https://wa.me/?text=${message}%20${encodeURIComponent(previewImage)}%0ADownload full ticket: ${encodeURIComponent(pdfUrl)}`;

    // window.open(shareUrl, '_blank');

  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleChangeCHeck = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.checked
    }));
  };

  const PayTypeModeHandle = (event) => {
    const { value, checked } = event.target;
    SetPayType(value)
  }
  return (
    <>
      {isLoading && BookingData.length === 0 ? (
        <>
          <div className="bg-gray-50 min-h-screen pb-16 mt-2">

            <ItineraryLoader />
          </div>
        </>
      ) : (
        <div className="bg-gray-50 min-h-screen pb-16 ">

          <div className="flex flex-col md:flex-row gap-6 max-w-6xl mx-auto px-4">

            {isDialogOpenHold && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                <form onSubmit={handleConfirmHold} className="mui-form">
                  <div className="bg-white rounded-md w-full max-w-lg p-6 shadow-lg relative">
                    <div className="flex justify-between items-center mb-4 border-b pb-2">
                      <h2 className="text-xl font-bold">{TitlesHold}</h2>
                      <button className="text-2xl font-semibold" onClick={handleClose}>&times;</button>
                    </div>
                    {formDataHold.action === 2 ? (
                      <>
                        <div className="mb-6">
                          <p className="mb-2 font-medium">Select PNR</p>
                          <div className="grid grid-cols-1 gap-y-3">
                            {BookingData.map((item, idx) => (
                              <label className="flex items-center gap-2" key={idx + 'release'}>
                                <input type="checkbox" value={item.PNRNumber} className="accent-blue-500 w-5 h-5" onChange={handleChangePNR} checked={formDataHold.pnrs.includes(item.PNRNumber)} />
                                <span className="font-semibold">{item.SoCode} → {item.DeCode} : {item.PNRNumber}</span>
                                <span className="text-sm font-normal text-gray-500">
                                  on {format(new Date(item.FromUTCTime), "MMM dd, EEE, HH:mm")}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>

                        <div className="text-right mt-4">
                          <button disabled={Processing} type='submit' className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition">
                            {Processing ? (
                              <span className="flex items-center">
                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing...
                              </span>
                            ) : (
                              <>Release</>
                            )}
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-600">
                              Booking ID
                            </label>
                            <input
                              type="text"
                              value={BookingData[0].BookingID}
                              readOnly
                              className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                              placeholder="Booking ID"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-600">
                              Amount to Pay
                            </label>
                            <input
                              type="text"
                              value={(formDataHold.paymentMode === '3') ? (fare.TotalGrand + fare.Totalagentmarkup) : fare.TotalGrand}
                              readOnly
                              className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                              placeholder="Amount to Pay"
                            />
                          </div>
                        </div>

                        <div className="mt-4">
                          <ul className="flex gap-6 mt-4 mb-4">
                            {fare.BookAmt > 0 && (
                              <>
                                <li>
                                  <label
                                    htmlFor="FullPay"
                                    className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                                  >
                                    <input
                                      type="radio"
                                      id="FullPay"
                                      value="1"
                                      name="PayType"
                                      onChange={PayTypeModeHandle}
                                      checked={PayType == 1}
                                      className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                    />
                                    <span className="text-sm font-medium text-gray-700">
                                      Full Pay:
                                      {usewallet ? (
                                        <>
                                          (<CurFt currency={fare?.symbol || "INR"} price={(fare?.TotalGrand + TotalSSR) - (fare?.CouponDiscount + bookable_balance)} />)
                                        </>
                                      ) : (
                                        <>
                                          (<CurFt currency={fare?.symbol || "INR"} price={(fare?.TotalGrand + TotalSSR) - fare?.CouponDiscount} />)
                                        </>
                                      )}

                                    </span>
                                  </label>
                                </li>
                                <li>
                                  <label
                                    htmlFor="Part"
                                    className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                                  >
                                    <input
                                      type="radio"
                                      id="Part"
                                      value="2"
                                      onChange={PayTypeModeHandle}
                                      name="PayType"
                                      checked={PayType == 2}
                                      className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                    />
                                    <span className="text-sm font-medium text-gray-700">
                                      Part Pay: (<CurFt currency={fare?.symbol || "INR"} price={fare.BookAmt + fare.ProAmt + fare.GSTOnPro} />)
                                    </span>
                                  </label>
                                </li>
                              </>
                            )}
                          </ul>

                          <ul className="grid grid-cols-1 sm:grid-cols-3 gap-1">
                            <li>
                              <label
                                htmlFor="FullPay"
                                className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-2 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                              >
                                <input
                                  type="radio"
                                  id="FullPay"
                                  value="1"
                                  name="paymentMode"
                                  onChange={paymentModeHandle}
                                  checked={formDataHold.paymentMode === '1'}
                                  className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                />
                                <span className="text-sm font-medium text-gray-700">
                                  Wallet
                                </span>
                              </label>
                            </li>
                            <li>
                              <label
                                htmlFor="Selfcard"
                                className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-2 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                              >
                                <input
                                  type="radio"
                                  id="Selfcard"
                                  value="2"
                                  name="paymentMode"
                                  onChange={paymentModeHandle}
                                  checked={formDataHold.paymentMode === '2'}
                                  className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                />
                                <span className="text-sm font-medium text-gray-700">
                                  Self Card
                                </span>
                              </label>
                            </li>
                            {PayType !== '2' && (
                              <li>
                                <label
                                  htmlFor="customercard"
                                  className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-2 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                                >
                                  <input
                                    type="radio"
                                    id="customercard"
                                    value="3"
                                    name="paymentMode"
                                    onChange={paymentModeHandle}
                                    checked={formDataHold.paymentMode === '3'}
                                    className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                  />
                                  <span className="text-sm font-medium text-gray-700">
                                    Customer Card
                                  </span>
                                </label>
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="text-right mt-4">
                          <button
                            variant="contained"
                            size="large"
                            type="submit"
                            disabled={Processing}
                            className={`px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition ${Processing
                              ? 'bg-gray-400 cursor-not-allowed'
                              : 'bg-blue-500 hover:bg-blue-600'
                              }`}
                          >
                            {Processing ? (
                              <>
                                Please wait...
                              </>
                            ) : (
                              <>
                                Proceed To Pay
                              </>

                            )}
                          </button>
                          {HoldPaymentStatus === 1 && (
                            <span className=" flex items-center gap-1">
                              <div className="flex flex-col items-center justify-center">
                                <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                                <span className="font-semibold text-orange-600">Checking booking status please wait...</span>
                              </div>
                            </span>
                          )}
                          {HoldPaymentStatus === 0 && isBookingStatus === 1 && (
                            <span className=" flex items-center gap-1">
                              <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
                              <h2 className="text-xl font-bold text-green-600">
                                Booking Success
                              </h2>
                              <button
                                onClick={ViewTicketDetails}
                                className="mt-6 bg-green-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-green-700 transition"
                              >
                                View Ticket
                              </button>
                            </span>
                          )}


                        </div>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            )}
            {isDialogOpen && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                <div className="bg-white rounded-md w-full max-w-md p-6 shadow-lg relative">
                  <div className="flex justify-between items-center mb-4 border-b pb-2">
                    <h2 className="text-xl font-bold">{Titles}</h2>
                    <button className="text-2xl font-semibold" onClick={handleClose}>&times;</button>
                  </div>
                  {formData.action == 2 && (
                    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
                      <div>
                        <label className="block text-sm font-medium mb-1">Enter Name</label>
                        <input type="text" name='Name' onChange={handleChange} className="w-full border rounded-lg px-3 py-2" placeholder="Name" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Enter Email</label>
                        <input type="email" name='emailid' onChange={handleChange} className="w-full border rounded-lg px-3 py-2" placeholder="Email ID" />
                      </div>
                    </div>
                  )}

                  {(formData.action == 4 || formData.action == 5) && (
                    <>

                    </>
                  )}
                  {(formData.action == 6 || formData.action == 7) && (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
                        {(formData.action == 7) && (
                          <div>
                            <label className="block text-sm font-medium mb-1">Enter Discount</label>
                            <input type="text" name='Discount' value={formData.Discount} onChange={handleChange} className="w-full border rounded-lg px-3 py-2" placeholder="Discount Fixed" />
                          </div>
                        )}

                        {(formData.action == 6) && (
                          <>
                            <div>
                              <label className="block text-sm font-medium mb-1">Enter amount</label>
                              <input type="number" name='amount' value={formData.amount} onChange={handleChange} className="w-full border rounded-lg px-3 py-2" placeholder="Amount" />
                            </div>
                            <div>
                              <label className="block text-sm font-medium mb-1">Display Txn Fee</label>
                              <select name='displayServiceFee' value={formData.displayServiceFee} className="w-full border rounded-lg px-3 py-2" onChange={handleChange}>
                                <option value={1}>Show in Tax</option>
                                <option value={2}>Show Separately</option>
                              </select>
                            </div>
                          </>
                        )}

                      </div>
                    </>
                  )}
                  {user?.UserData?.user?.UserType == 2 && (formData.action == 1 || formData.action == 2 || formData.action == 3 || formData.action == 4 || formData.action == 5) && (
                    <>
                      <div className="mb-4">
                        <p className="mb-2 font-medium">Select Desire Pricing Option (you can select only one option)</p>
                        <div className="flex gap-6">
                          <label className="flex items-center gap-2">
                            <input type="radio" name="showPrice" onChange={handleChange} value={1} className="accent-blue-500" defaultChecked />
                            <span className="font-semibold">With Price</span>
                          </label>
                          <label className="flex items-center gap-2">
                            <input type="radio" name="showPrice" onChange={handleChange} value={2} className="accent-blue-500" />
                            <span className="font-semibold">Without Price</span>
                          </label>
                        </div>
                      </div>

                      <div className="mb-6">
                        <p className="mb-2 font-medium">Select Other Options</p>
                        <div className="grid grid-cols-2 gap-y-3">
                          <label className="flex items-center gap-2">
                            <input type="checkbox" name='agentDetails' className="accent-blue-500" onChange={handleChangeCHeck} defaultChecked />
                            <span className="font-semibold">With Agency</span>
                          </label>
                          <label className="flex items-center gap-2">
                            <input type="checkbox" name='tax' className="accent-blue-500" onChange={handleChangeCHeck} defaultChecked />
                            <span className="font-semibold">With GST</span>
                          </label>
                          <label className="flex items-center gap-2">
                            <input type="checkbox" name='passportInfo' className="accent-blue-500" onChange={handleChangeCHeck} defaultChecked />
                            <span className="font-semibold">Passport Info</span>
                          </label>

                        </div>
                      </div>
                    </>
                  )}

                  <div className="text-right mt-4">
                    <button disabled={Processing} onClick={handleConfirm} type='button' className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition">
                      {Processing ? (
                        <span className="flex items-center">
                          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Processing...
                        </span>
                      ) : (
                        <>Submit</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Flight details */}
            <div className="flex-1 space-y-6">
              {/* <h2 className="text-xl font-semibold">Flight Details</h2>  */}

              <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                {/* Header */}
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold">
                    {BookingData[0]?.BookingStatus === 22 || BookingData[0]?.BookingStatus === 3 || BookingData[0]?.BookingStatus === 31 ? (
                      <StepFailed icon={<CheckCircle className="w-5 h-5 text-white" />} title={BOOKINGSTATUSS[BookingData[0]?.BookingStatus]} subtitle={BookingData[0]?.BookingID} active />
                    ) : (
                      <>
                        {BookingData.map((f, idx) => (
                          <Step icon={<CheckCircle className="w-5 h-5 text-white" />} title={`${BOOKINGSTATUSS[f?.BookingStatus]} - ${f.SoCity} → ${f.DeCity}`} subtitle={f?.BookingID} active />
                        ))}
                      </>

                    )}
                  </h3>
                  {isBookingStatus === 0 ? (
                    <>
                      <span className=" flex items-center gap-1">
                        <div className="flex flex-col items-center justify-center">
                          <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                          <span className="font-semibold text-orange-600">Checking booking status please wait...</span>
                        </div>
                      </span>
                    </>
                  ) : (
                    <>
                      {(() => {
                        if (isBookingStatus === 1 || isBookingStatus === 29 || isBookingStatus === 9 || isBookingStatus === 7) {
                          return (
                            <span className=" flex items-center gap-1">
                              <div className="relative inline-block text-left">
                                {PNRNumber.split(',').map((pnr, index) => (
                                  <p key={index}>PNR : <span className="font-semibold text-blue-500">{pnr.trim()}</span></p>
                                ))}
                                {GDSPNRNumber.replace(/[,\s]/g, "") && (
                                  <p>GDS PNR : <span className="font-semibold text-blue-500">{GDSPNRNumber}</span></p>
                                )}
                              </div>

                            </span>
                          )
                        } else if (isBookingStatus === 20) {
                          return (
                            <span className=" flex items-center gap-1">
                              <div className="relative inline-block text-left">
                                <p><span className="font-semibold text-orange-500">Ticket Pending</span></p>
                              </div>
                            </span>
                          )
                        } else if (isBookingStatus === 3) {
                          return (
                            <span className=" flex items-center gap-1">
                              <div className="relative inline-block text-left">
                                <p><span className="font-semibold text-red-500">Payment Done Booking Failed</span></p>
                              </div>
                            </span>
                          )
                        } else if (isBookingStatus === 26) {
                          return (
                            <>
                              <span className=" flex items-center gap-1">
                                <div className="relative inline-block text-left">
                                  <p><span className="font-semibold text-red-500">Ticket Hold</span></p>
                                  {timeLimit === '0000-00-00 00:00:00' ? (
                                    <p><span className="font-normal text-red-500">Time-limit not available.</span></p>
                                  ) : (
                                    <p><span className="font-normal text-red-500">Time-limit for this booking is {format(new Date(timeLimit), "MMM dd, EEE, HH:mm")} , please ensure to issue ticket before time limit.</span></p>
                                  )}

                                </div>
                              </span>
                              <span className="font-semibold text-blue-500 flex items-center gap-1">
                                <div className="relative inline-block text-left">
                                  <button
                                    onClick={() => setOpen(!open)}
                                    className="inline-flex items-center px-4 py-2 bg-blue-500 text-white font-medium rounded-lg shadow hover:bg-blue-600 transition"
                                  >
                                    Options
                                    <ChevronDown className="w-4 h-4 ml-2" />
                                  </button>
                                  {open && (
                                    <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                                      <div className="py-2">
                                        <button onClick={() => handleHold('Confirm Ticket', 1)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                          Confirm Ticket
                                        </button>
                                        <button onClick={() => handleHold(' Unhold Ticket', 2)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                          Unhold Ticket
                                        </button>

                                      </div>
                                    </div>
                                  )}
                                </div>
                              </span>
                            </>
                          )
                        } else {
                          return (
                            <>
                              {/* <span className=" flex items-center gap-1">
                              <div className="flex flex-col items-center justify-center">
                                <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                                <span className="font-semibold text-orange-600"> Payment Done Booking Processing...</span>
                              </div>
                            </span> */}
                            </>
                          )
                        }
                      })()}

                      {(isBookingStatus === 1 || isBookingStatus === 29 || isBookingStatus === 9 || isBookingStatus === 7) && (
                        <span className="font-semibold text-blue-500 flex items-center gap-1">
                          <div className="relative inline-block text-left">
                            <button
                              onClick={() => setOpen(!open)}
                              className="inline-flex items-center px-4 py-2 bg-blue-500 text-white font-medium rounded-lg shadow hover:bg-blue-600 transition"
                            >
                              Ticket Options
                              <ChevronDown className="w-4 h-4 ml-2" />
                            </button>
                            {open && (
                              <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                                <div className="py-2">
                                  <button onClick={() => handleOpen('Print Ticket', 1)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                    Print Ticket
                                  </button>
                                  <button onClick={() => handleOpen('Email Ticket', 2)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                    Email Ticket
                                  </button>
                                  <button onClick={() => handleOpen('Download PDF Ticket', 3)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                    Download as PDF
                                  </button>
                                  <button onClick={() => handleOpen('My Invoice', 8)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                    My Invoice
                                  </button>
                                  <button onClick={() => handleOpen('Customer Invoice', 9)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                    Customer Invoice
                                  </button>
                                  {user?.UserData?.user?.UserType == 2 && (
                                    <>
                                      <button onClick={() => handleOpen('Edit Transaction Fee', 6)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                        Edit Transaction Fee
                                      </button>
                                      <button onClick={() => handleOpen('Add Discount', 7)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                        Add Discount
                                      </button>
                                    </>
                                  )}

                                  <a target='_blank' href={`/flight/amendment/${BookingData[0]?.BookingID}`} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                    Raise Amendment
                                  </a>
                                </div>
                              </div>
                            )}
                          </div>
                        </span>
                      )}
                    </>
                  )}
                </div>
                {(BookingData[0]?.is_amendments === 1 || BookingData[0]?.BookingStatus === 31 || BookingData[0]?.BookingStatus === 30) && (
                  <span className="font-normal text-red-500  items-center gap-1">
                    <div className="relative inline-block text-left w-full">
                      <b>Remarks: -</b> {BookingData[0]?.Errormessage}
                      {notes?.id > 0 && (
                        <>
                          <div>
                            <table className="w-full text-sm text-left text-gray-600 border">
                              <thead className="bg-blue-200 text-gray-800">
                                <tr>
                                  <th className="px-4 py-2 border">Note</th>
                                  <th className="px-4 py-2 border" width="20%">Date Time </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="px-4 py-2 border bg-cyan-50">{notes.title} - {notes.message}</td>
                                  <td className="px-4 py-2 border bg-blue-50" nowrap="true">
                                    {Moment(notes.created_at).format('ddd Do MMM YYYY HH:mm')}
                                    <br /> Refernece No. : {notes.referneceNo ? '(' + notes.referneceNo + ')' : ''}
                                    {notes.charges > 0 && (
                                      <>
                                        <br />Charges : {notes.charges}
                                      </>
                                    )}
                                    {notes.payment_allowed && (
                                      <>
                                        <br /><button type="button" className="bg-blue-500 text-white px-5 py-2 rounded-md hover:blue-600 transition bg-blue-500 hover:bg-blue-600 mt-2">Pay Now</button>
                                      </>
                                    )}

                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}

                    </div>
                  </span>
                )}
                <span className="font-normal text-red-500  items-center gap-1">
                  <p>{remarks}</p>
                </span>
              </div>

              {BookingData.map((f, idx) => (
                <div key={idx} className="bg-white rounded-lg shadow p-4 space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold">
                      {f.SoCity} → {f.DeCity} &nbsp;
                      <span className="text-sm font-normal text-gray-500">
                        on {format(new Date(f.FromUTCTime), "MMM dd, EEE, HH:mm")}
                      </span>
                    </h3>
                    <span className="text-sm text-gray-500 flex items-center gap-1">
                      <Clock className="w-4 h-4" /> {f.Duration}
                    </span>
                  </div>

                  {f.Segments.map((SegItem, Segkey) => (
                    <div key={Segkey}>
                      <div className="flex items-start gap-4 rounded-lg bg-white">
                        {/* Airline Logo + Name */}
                        <div className="w-1/5 flex items-center gap-3">
                          <div className="w-12 h-12 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                            <img
                              src={SegItem.filePath}
                              alt={SegItem.AirlineName}
                              className="object-contain w-full h-full"
                            />
                          </div>
                          <div>
                            <div className="font-semibold">
                              {SegItem.AirlineName} &nbsp;
                              <div className="text-gray-500">{SegItem.FlightNumber}</div>
                            </div>
                          </div>
                        </div>

                        {/* Origin */}
                        <div className="w-1/5">
                          <p className="font-bold">
                            {format(new Date(SegItem.originDepTime), "MMM dd, EEE, HH:mm")}
                          </p>
                          <p className="text-sm text-gray-600">
                            {SegItem.originCityName}, {SegItem.originCountryName}
                          </p>
                          <p className="text-sm text-gray-600">{SegItem.originAirportName}</p>
                          <p className="text-xs text-gray-400">Terminal {SegItem.DepTerminal}</p>
                        </div>

                        {/* Arrow (centered) */}
                        <div className="w-1/5 flex items-center justify-center">
                          <ArrowRight className="w-7 h-7 text-gray-400" />
                        </div>

                        {/* Destination */}
                        <div className="w-1/5">
                          <p className="font-bold">
                            {format(new Date(SegItem.destinationArrTime), "MMM dd, EEE, HH:mm")}
                          </p>
                          <p className="text-sm text-gray-600">
                            {SegItem.destinationCityName}, {SegItem.destinationCountryName}
                          </p>
                          <p className="text-sm text-gray-600">{SegItem.destinationAirportName}</p>
                          <p className="text-xs text-gray-400">Terminal {SegItem.ArrTerminal}</p>
                        </div>

                        {/* Duration & Fare Info */}
                        <div className="w-1/5">
                          <p className="font-bold">{SegItem.FlightDuration}</p>
                          <p className="text-sm text-gray-600">{f.FareLists.FareClass}</p>
                          <p className="text-sm text-red-600">{f.FareLists.fareIdentifier}</p>
                          <p className="text-xs text-gray-400">{f.FareLists.RefundableTxt}</p>
                        </div>
                      </div>



                      {/* Layover (if not last segment) */}
                      {SegItem.GroundTime > 0 && (
                        <div className="text-center my-4">
                          <span className="bg-blue-500 text-white text-xs px-3 py-1 rounded-full font-medium">
                            Change Plane at {SegItem.LAYOVERCity}, Layover Time : {SegItem.LAYOVERDuration}
                          </span>
                        </div>
                      )}

                      <div className="text-sm text-gray-600 border-b pt-2 pb-2">
                        <p>
                          🧳 (Adult) Check-in:{f.FareLists.Checkin} Cabin: {f.FareLists.Cabin}
                        </p>
                      </div>
                    </div>
                  ))}


                  <div className="mt-4">
                    <div className="flex items-start justify-between">
                      <h3 className=" font-semibold text-gray-800">
                        Passenger Details ({customer.length})
                      </h3>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />
                    <div className="mt-3 overflow-x-auto ">
                      <table className="min-w-full border  text-sm">
                        <thead className="bg-gray-100 text-gray-700">
                          <tr>
                            <th className="px-3 py-2 border">#</th>
                            <th className="px-3 py-2 border text-left">Name & Age</th>
                            <th className="px-3 py-2 border text-left">Sector</th>
                            <th className="px-3 py-2 border text-left whitespace-nowrap">
                              Checkin | Cabin
                            </th>
                            <th className="px-3 py-2 border text-left" colSpan="3">
                              Seat, Baggage & Meal
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {f.Travellers.length > 0 &&
                            f.Travellers.map((citem, keys) => (
                              <tr
                                key={keys + "customer"}
                                className=" border-b"
                              >
                                <td className="px-3 py-2 border text-center font-medium">
                                  {keys + 1}
                                </td>
                                <td className="px-3 py-2 border whitespace-nowrap text-gray-800">
                                  {citem.title}. {citem.fname} {citem.lname} ({citem.PaxType}) <br />
                                  {citem.docid && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.docid ? "ID-" + citem.docid : ""}
                                      </small>
                                      <br />
                                    </>
                                  )}
                                  {citem.dateofbirth && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.dateofbirth ? "DOB-" + citem.dateofbirth : ""}
                                      </small>
                                      <br />
                                    </>
                                  )}
                                  {citem.passno && (
                                    <>
                                      <small className="text-gray-500">
                                        {citem.passno ? "Passport No-" + citem.passno : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno
                                          ? "Passport Expiry-" +
                                          Moment(citem.passexp).format("Do MMM YYYY")
                                          : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno
                                          ? "Passport Issue-" +
                                          Moment(citem.passisse).format("Do MMM YYYY")
                                          : ""}
                                      </small>
                                      <br />
                                      <small className="text-gray-500">
                                        {citem.passno ? "Issue Country-" + citem.passnational : ""}
                                      </small>
                                    </>
                                  )}
                                  {citem.FFdetail.length > 0 &&
                                    citem.FFdetail.map((ffv, kf) => (
                                      <React.Fragment key={"ItemsSeg" + kf}>
                                        {ffv.FFNumber && (
                                          <>
                                            <small className="text-gray-500">
                                              Frequent Flyer Airline: {ffv.FFAirlineCode}
                                            </small>
                                            <br />
                                            <small className="text-gray-500">
                                              Frequent Flyer No: {ffv.FFNumber}
                                            </small>
                                          </>
                                        )}
                                      </React.Fragment>
                                    ))}

                                  <br />
                                  {(citem.is_amendments === 1 || citem.is_amendments === 9) && (
                                    <small className="text-xs text-red-500">
                                      CAN/MODE -&nbsp;
                                    </small>
                                  )}
                                  {(citem.status) && (
                                    <small className={citem.status === 1 ? 'text-xs text-green-500' : 'text-xs text-red-500'}>
                                      {citem.status === 1 ? 'CONFIRMED' : 'CANCELLED'}
                                    </small>
                                  )}
                                </td>
                                <td className="px-3 py-2 border whitespace-nowrap">
                                  {citem.sector.map((sec, k) => (
                                    <div key={k} className="mb-2" style={{ width: '100%' }}>
                                      <div className="float-left text-1 font-weight-500 text-dark" style={{ width: '100%' }}>
                                        {sec} - <span className="text-blue-600 font-medium">{citem.PNRNumber[k]}</span>
                                        {citem.ticketid[k] && (
                                          ('(' + citem.ticketid[k] + ')')
                                        )}

                                      </div>
                                    </div>
                                  ))}
                                </td>
                                <td className="px-3 py-2 border text-gray-700">
                                  {citem.CheckinBaggage} | {citem.CabinBaggage}
                                </td>
                                <td className="px-3 py-2 border whitespace-nowrap" colSpan="3">
                                  {Object.keys(citem.SelectedSeat).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedSeat.map((addons, ad) => (
                                        <li key={ad + "selectedseat"}>
                                          Seat No - {addons[0].seatNo}
                                        </li>
                                      ))}
                                    </ul>
                                  )}

                                  {Object.keys(citem.SelectedBag).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedBag.map((addons, ad) => (
                                        <li key={ad + "selectedbag"}>{addons[0].Weight}</li>
                                      ))}
                                    </ul>
                                  )}
                                  {Object.keys(citem.SelectedMeal).length > 0 && (
                                    <ul className="list-disc list-inside text-gray-700">
                                      {citem.SelectedMeal.map((addons, ad) => (
                                        <li key={ad + "selectedmeal"}>
                                          {addons[0].Description}
                                        </li>
                                      ))}
                                    </ul>
                                  )}

                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ))}

              <form className="mui-form">
                <>

                  <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    <div className="flex items-start justify-between">
                      <h3 className=" font-semibold text-gray-800">
                        Contact Details
                      </h3>
                    </div>
                    <hr className="border-t border-gray-200 my-3" />
                    <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-600">Mobile</label>
                        <span className="text-body">+{customer[0]?.countrycode} {customer[0]?.mobile}</span>
                      </div>
                      <div className="sm:col-span-2 relative">
                        <label className="block text-sm font-medium text-gray-600">Email</label>
                        <span className="text-body">{customer[0]?.email}</span>
                      </div>
                    </div>
                  </div>
                </>
              </form>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 max-w-6xl mx-auto mt-4 px-4">
            <aside className="w-full md:w-100 bg-white rounded-lg shadow p-4 space-y-4 self-start">
              <h3 className="font-semibold">Fare Summary </h3>
              <FareSummary params={params} fare={fare} BookingData={BookingData} SeatPrice={SeatPrice} TotalBagPrice={TotalBagPrice} TotalMealPrice={TotalMealPrice} TotalSSR={TotalSSR} user={user} review={true} />
            </aside>
          </div>
          <div className="flex flex-col md:flex-row gap-6 max-w-6xl mx-auto mt-4 px-4">
            <div className="rounded-lg border bg-blue-100 p-4 md:p-4 shadow-sm break-inside-avoid w-full">
              <h3 className="text-base md:text-lg font-semibold mb-3">Important Information</h3>
              <ul className="list-disc pl-5 space-y-2 text-sm leading-relaxed text-gray-700">
                <li>You should carry a print-out of your booking and present for check-in.</li>
                <li>Date &amp; Time is calculated based on the local time of city/destination.</li>
                <li>Use the Reference Number for all Correspondence with us.</li>
                <li>Use the Airline PNR for all Correspondence directly with the Airline.</li>
                <li>For departure terminal please check with airline first.</li>
                <li>Please CheckIn atleast 2 hours prior to the departure for domestic flight and 3 hours prior to the departure of international flight.</li>
                <li>For rescheduling/cancellation within 4 hours of departure time contact the airline directly.</li>
              </ul>
            </div>

          </div>

          <Dialog
            open={isSectorModalOpen}
            onClose={() => setIsModalSector(false)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6 flex flex-col items-center justify-center text-center">

              {(() => {
                if (bookingStatus === "loading") {
                  return (
                    <>
                      <h2 className="text-lg font-semibold border-b pb-2 w-full text-center">
                        Booking Process...
                      </h2>
                      <div className="mt-6 flex flex-col items-center justify-center">
                        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                        <p className="mt-4 text-gray-600">
                          Please do not go back or press any button. <br />
                          This might take a few seconds.
                        </p>
                      </div>
                    </>
                  )
                } else if (bookingStatus === "success") {
                  return (
                    <>
                      <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
                      <h2 className="text-xl font-bold text-green-600">
                        Booking Success
                      </h2>
                      <p className="mt-2 text-gray-700">
                        Booking Success with booking Id-<br />
                        <span className="font-medium">{BookingData[0].BookingID}</span>. <br />
                        Have a great journey 😍
                      </p>
                      <button
                        onClick={ViewTicketDetails}
                        className="mt-6 bg-green-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-green-700 transition"
                      >
                        View Ticket Details
                      </button>
                    </>
                  )
                } else {
                  return (
                    <>
                      <CircleX className="w-16 h-16 text-red-500 mb-4" />
                      <h2 className="text-xl font-bold text-red-600">
                        Booking Failed
                      </h2>
                      <p className="mt-2 text-gray-700">
                        {ErrorMessage}!<br />
                        <span className="font-medium"> note down these Id for further support. RefId: </span>. <br />
                        {BookingData[0].BookingID} 😞
                      </p>
                      <button
                        onClick={TryAgain}
                        className="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                      >
                        Try Again
                      </button>
                    </>
                  )
                }
              })()}
            </div>
          </Dialog>

        </div>
      )
      }
    </>
  );
}

// Stepper component
const Step = ({ icon, title, subtitle, active }) => (
  <div className="flex items-center flex-1">
    <div
      className={`flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 ${active ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-500"
        }`}
    >
      {icon}
    </div>
    <div className="ml-2">
      <p
        className={`text-mb ${active ? "font-bold text-blue-500" : "text-gray-600"
          }`}
      >
        {title}
      </p>
      <span className={`text-mb ${active ? "text-blue-500" : "text-mb text-gray-400"}`}>{subtitle}</span>
    </div>
  </div>
);

const StepFailed = ({ icon, title, subtitle, active }) => (
  <div className="flex items-center flex-1">
    <div
      className={`flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 ${active ? "bg-red-500 text-white" : "bg-gray-200 text-gray-500"
        }`}
    >
      {icon}
    </div>
    <div className="ml-2">
      <p
        className={`text-mb ${active ? "font-bold text-red-500" : "text-gray-600"
          }`}
      >
        {title}
      </p>
      <span className={`text-mb ${active ? "text-red-500" : "text-mb text-gray-400"}`}>{subtitle}</span>
    </div>
  </div>
);
